<template>
  <m-categories-wrapper>
    <template slot-scope="{ categories,imageHandler,setLinkType }">

      <swiper id="sliderCategories303" class="w-100" ref="mySwiper" :options="swiperOptions">

        <swiper-slide v-for="category in categories" :key="category.id" class=" ">

          <b-col class="text-center">
            <m-a :href="setLinkType(category,linkType)">
              <m-c21 :alt="category.name" :img="imageHandler(category,alternativeCategoryImage)">
                <template #p-1>
                  <h4>{{ category.name }}</h4>
                </template>
              </m-c21>
            </m-a>
          </b-col>

        </swiper-slide>

        <div class="swiper-pagination" slot="pagination"></div>
        <div class="swiper-button-prev" slot="button-prev"></div>
        <div class="swiper-button-next" slot="button-next"></div>
      </swiper>


    </template>
  </m-categories-wrapper>
</template>

<script>
import {directive, Swiper, SwiperSlide} from "vue-awesome-swiper";
import {findAttributeOnSiteInfo} from "@moeinmdn/mixitweb-front-modules/src/plugin/class/FindAttributeOnSiteInfo";

export default {
  name: "Categories303",
  props: {
    alternativeCategoryImage: {
      default: () => {
        return findAttributeOnSiteInfo('icon')[0]
      }
    },
    linkType: {
      default: 'blog'
    }
  },
  components: {Swiper, SwiperSlide, directive},
  data() {
    return {
      swiperOptions: {
        slidesPerView: 4,
        autoplay: {
          delay: 2000,
        },
        breakpoints: {
          300: {
            slidesPerView: 1,
          },
          480: {
            slidesPerView: 2,
          },
          768: {
            slidesPerView: 2,
          },
          980: {
            slidesPerView: 3,
          },
          1200: {
            slidesPerView: 4,

          },
        },
        pagination: {
          el: '.swiper-pagination',
          clickable: true,
          dynamicBullets: true
        },
        navigation: {
          nextEl: ".swiper-button-next",
          prevEl: ".swiper-button-prev",
        },
      },
    };
  },
};
</script>

<style>
#sliderCategories302:hover > .swiper-wrapper .swiper-slide div a button {
  background-color: var(--primary) !important;
  color: var(--light) !important;
  transition-duration: 0.4s;
  height: 50px;
  border: none !important;
}

/* slider buttons */
#sliderCategories302 .swiper-button-next, #sliderCategories302 .swiper-button-prev {
  color: var(--secondary) !important;
}

#sliderCategories302 .swiper-pagination-bullet, #sliderCategories302 .swiper-pagination-bullet-active, #sliderCategories302 .swiper-pagination-bullet-active-main {
  color: var(--primary) !important;
  background: var(--primary) !important;
}

/* slider buttons */
</style>

<style scoped>
.image-size {
  width: 192px;
  height: 192px;
}

</style>
